import { useAppSelector } from "@/app/appStore";
import {
  selectAnnotationData,
  selectGondolaDropdownValue,
  selectIsSkuSectionPlanogramVisible,
  selectSelectedOrder,
  selectAnnotationView,
} from "@/entities/annotation";

import { usePlanogram } from "../lib/usePlanogram";
import { ANNOTATION_TYPES } from "@/entities/annotation/model/consts";
import useCameraHandlers from "../hooks/useCameraHandlers";
import useGondolaHandlers from "../hooks/useGondolaHandlers";
import AnnotationHeaderPlanogram from "./annotation-header-planogram";
import AnnotationHeaderDefault from "./annotation-header-default";

const AnnotationHeader = ({
  hasAnnotationViewSelector = true,
  hasGondolaSelectDisabled = false,
  onOpenMap,
}: {
  hasAnnotationViewSelector?: boolean;
  hasGondolaSelectDisabled?: boolean;
  onOpenMap?: () => void;
}) => {
  const isSkuSectionPlanogramViewVisible = useAppSelector(
    selectIsSkuSectionPlanogramVisible
  );
  const gondolaDropdownValue = useAppSelector(selectGondolaDropdownValue);
  const selectedOrder = useAppSelector(selectSelectedOrder);
  const annotationView = useAppSelector(selectAnnotationView);
  const annotationData = useAppSelector(selectAnnotationData);

  const isProximityTimeRangesAnnotation =
    annotationView === ANNOTATION_TYPES.PROXIMITY_TIME_RANGES &&
    !!annotationData;

  const { handleCameraSelect } = useCameraHandlers();
  const { handleGondolaChange, handleClosePlanogramView } =
    useGondolaHandlers();

  usePlanogram();

  const isGondolaDisabled =
    hasGondolaSelectDisabled ||
    !selectedOrder ||
    isProximityTimeRangesAnnotation;

  if (isSkuSectionPlanogramViewVisible) {
    return (
      <AnnotationHeaderPlanogram
        gondolaDropdownValue={gondolaDropdownValue}
        isGondolaDisabled={isGondolaDisabled}
        onGondolaChange={handleGondolaChange}
        onCameraSelect={handleCameraSelect}
        onClosePlanogramView={handleClosePlanogramView}
      />
    );
  }

  return (
    <AnnotationHeaderDefault
      hasAnnotationViewSelector={hasAnnotationViewSelector}
      gondolaDropdownValue={gondolaDropdownValue}
      isGondolaDisabled={isGondolaDisabled}
      onGondolaChange={handleGondolaChange}
      onCameraSelect={handleCameraSelect}
      onOpenMap={onOpenMap}
      isOrderSelected={!!selectedOrder}
    />
  );
};

export default AnnotationHeader;
